export enum AccountSign {
Debit,
Credit,
DebitAndCredit,
NoTransactions,
}
